<div appOverflowHidden>
    <ng-content></ng-content>
</div>
